/* MUNT storefront behaviour */
(function () {
  function store(key, val) {
    try { if (val === undefined) return localStorage.getItem(key); localStorage.setItem(key, val); } catch (e) { return null; }
  }
  var jsonHeaders = { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* 1. Reserve buttons: add to cart and open the drawer, no detour through the product page */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-munt-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: parseInt(btn.dataset.muntAdd, 10), quantity: 1 }] };
    if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
    var addUrl = (window.routes && window.routes.cart_add_url) || (root + 'cart/add');
    fetch(addUrl, { method: 'POST', headers: jsonHeaders, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { window.location.href = btn.getAttribute('href'); return; }
        if (drawer && res.sections && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents({ id: res.items && res.items[0] ? res.items[0].id : null, sections: res.sections });
        } else {
          window.location.href = root + 'cart';
        }
      })
      .catch(function () { window.location.href = btn.getAttribute('href'); })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  });

  /* 2. A/B test on the product page: price inside the add-to-cart button, or not */
  document.addEventListener('DOMContentLoaded', function () {
    var submit = document.querySelector('.product-form__submit');
    if (!submit) return;
    var arm = store('munt_ab_btn_price');
    if (arm !== 'price' && arm !== 'plain') { arm = Math.random() < 0.5 ? 'price' : 'plain'; store('munt_ab_btn_price', arm); }
    document.documentElement.setAttribute('data-ab-btn', arm);
    if (arm === 'price' && !submit.disabled) {
      var label = submit.querySelector('span');
      var priceEl = document.querySelector('.product__info-container .price-item--regular');
      var price = priceEl ? priceEl.textContent.trim() : '';
      if (label && price) label.textContent = label.textContent.trim() + ' — ' + price;
    }
    var sent = false;
    submit.addEventListener('click', function () {
      if (sent) return; sent = true;
      fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: { ab_button_price: arm } }) }).catch(function () {});
    });
  });
})();
